import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center h-screen text-center lg:text-left text-cebai-primary" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl md:text-4xl font-robotoBold" }, "Sport Sparks", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-4xl md:text-8xl font-robotoBold" }, "404", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl lg:text-3xl font-robotoMedium mt-5" }, " Oops. This page has gone missing. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg my-3" }, " You may have mistyped the address or the page may have moved. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButtonRouterLink = _resolveComponent("AppButtonRouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createVNode(_component_AppButtonRouterLink, {
      to: {
        name: 'home',
      },
      type: "primary"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Back to Home ")
      ]),
      _: 1
    })
  ]))
}